import cn from "classnames";
import kebabCase from "lodash/kebabCase";
import { type HTMLAttributes, type PropsWithChildren } from "react";
import { SiteBuilderModuleType } from "@/constants/site-builder";
import type { BaseSiteBuilderModule } from "@/types/site-builder";
import ModuleUI from "../ModuleUI";

export function getExternalClassName(name: string) {
  return `informa-${name}-module`;
}

const moduleClassNames: Record<SiteBuilderModuleType, string> = {
  [SiteBuilderModuleType.Accordion]: getExternalClassName("accordion"),
  [SiteBuilderModuleType.ButtonGroup]: getExternalClassName("button-group"),
  [SiteBuilderModuleType.ColumnText]: getExternalClassName("column-text"),
  [SiteBuilderModuleType.CustomForm]: getExternalClassName("custom-form"),
  [SiteBuilderModuleType.DropColumn]: getExternalClassName("drop-column"),
  [SiteBuilderModuleType.ExhibitorList]: getExternalClassName("exhibitor-list"),
  [SiteBuilderModuleType.FileDownload]: getExternalClassName("file-download"),
  [SiteBuilderModuleType.Hero]: getExternalClassName("hero"),
  [SiteBuilderModuleType.HeroCarousel]: getExternalClassName("hero-carousel"),
  [SiteBuilderModuleType.HtmlBlock]: getExternalClassName("html-block"),
  [SiteBuilderModuleType.Iframe]: getExternalClassName("iframe"),
  [SiteBuilderModuleType.Image]: getExternalClassName("image"),
  [SiteBuilderModuleType.ImageGallery]: getExternalClassName("image-gallery"),
  [SiteBuilderModuleType.Speakers]: getExternalClassName("speakers"),
  [SiteBuilderModuleType.SponsorCategory]: getExternalClassName("sponsors"),
  [SiteBuilderModuleType.Statistics]: getExternalClassName("statistics"),
  [SiteBuilderModuleType.Testimonial]: getExternalClassName("testimonial"),
  [SiteBuilderModuleType.TextContent]: getExternalClassName("text-content"),
  [SiteBuilderModuleType.Video]: getExternalClassName("video"),
  [SiteBuilderModuleType.VideoGallery]: getExternalClassName("video-gallery"),
};

export interface WrapperProps
  extends Pick<HTMLAttributes<HTMLElement>, "className"> {
  module: BaseSiteBuilderModule;
}

export default function Wrapper(props: PropsWithChildren<WrapperProps>) {
  const { module, className: customClassName, children } = props;
  const {
    "@type": type,
    baseContent: { name },
    settings: { customCSSClassName },
    style: {
      display: { displayStyle, displayVariant },
    },
  } = module;

  const className = cn(
    "informa-module",
    moduleClassNames[type],
    `informa-${kebabCase(displayStyle)}-display-style`,
    `informa-${kebabCase(displayVariant)}-display-variant`,
    customCSSClassName,
    customClassName,
  );
  const sectionId = kebabCase(name) || undefined;

  return (
    <ModuleUI module={module} id={sectionId} className={className}>
      {children}
    </ModuleUI>
  );
}
